/**
 * Handles clearing of elements before they get revealed
 * @module embed/clear_before_show
 */
import { delegate } from '@/lib/events';

const SELECTOR = '.js-clear-before-show';
const ATTR_TYPE = 'data-clear-before-show-type';
const ATTR_VALUE = 'data-clear-before-show-value';
/**
 * @param {HTMLElement} el The element to clear
 */
export function setupClearBeforeShow(el) {
  el.addEventListener(
    'willShow',
    delegate(SELECTOR, ({ target }) => {
      // Add reset for other kind of fields as needed
      if (target.getAttribute(ATTR_TYPE) == 'radioGroup') {
        target.querySelector(
          `[type="radio"][value="${target.getAttribute(ATTR_VALUE)}"]`
        ).checked = true;
      }
      Array.from(target.querySelectorAll('[type="checkbox"]')).forEach(
        el => (el.checked = false)
      );
      Array.from(
        target.querySelectorAll('[type="text"],[type="number"]')
      ).forEach(el => (el.value = ''));
    })
  );
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/clear_before_show.js